import { toast, ToastId, ToastOptions } from 'react-toastify';

const defaultToastOptions: ToastOptions = {
  position: 'top-center',
  autoClose: 3000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
}

export const toastSuccess = (text: string, config?: ToastOptions): ToastId => toast.success(text, {
  ...defaultToastOptions,
  ...config,
})

export const toastError = (text: string, config?: ToastOptions): ToastId => toast.error(text, {
  ...defaultToastOptions,
  ...config,
});

export const toastInfo = (text: string, config?: ToastOptions): ToastId => toast.info(text, {
  ...defaultToastOptions,
  ...config,
});

export const toastWarn = (text: string, config?: ToastOptions): ToastId => toast.warn(text, {
  ...defaultToastOptions,
  ...config,
});
